export default __webpack_public_path__ + "static/media/awaria-band.1660f961.mp4";